import { type Temporal } from '@js-temporal/polyfill'

export default function serializeInstant (instant: Temporal.Instant): string {
  return instant.toString({ fractionalSecondDigits: 3 })
}
